import { FC, useCallback, useState } from 'react';

import type { FlowCallActionT } from 'components/powerCallFlow/api/types';
import { ConfirmModal } from 'components/shared/confirmModal/components/confirmModal';
import type { WithFlowsInjectedPropsT } from 'hocs';
import type { FlowT } from 'hocs/flows/api/types';

type PropsT = {
  isShown: boolean;
  selectedFlow: FlowT<FlowCallActionT> | null;
  onClose: () => void;
} & WithFlowsInjectedPropsT<FlowCallActionT>;

const RemoveFlowModal: FC<PropsT> = ({
  isShown,
  selectedFlow,
  flows,
  onClose,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const onConfirm = useCallback(() => {
    if (!selectedFlow) {
      return;
    }

    const { id } = selectedFlow;

    setIsLoading(true);

    flows
      .remove(id)
      .then(() => setIsLoading(false))
      .then(() => onClose());
  }, [selectedFlow, setIsLoading, onClose, flows]);

  if (!selectedFlow) {
    return null;
  }

  const { name } = selectedFlow;

  return (
    <ConfirmModal
      isShown={isShown}
      confirmText="Delete"
      cancelText="Cancel"
      headline="Delete flow"
      confirmProps={{ isLoading }}
      confirm={onConfirm}
      cancel={onClose}
    >
      <p>
        Are you sure you want to delete the <strong>{name}</strong> flow?
      </p>
    </ConfirmModal>
  );
};

export default RemoveFlowModal;
